import util from '../../lib/util';
import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import DeadlineRule from '../../entities/deadlineRule';
import Deadline from '../../entities/deadline';
import CourtDeadlineRule from '../../entities/courtDeadlineRule';
export function deleteDeadlineRule(deadlineRule: DeadlineRule, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = deadlineRule.id;}
const _work = workingSet();
store.getState().deadlines.getMappingFor('deadlineRuleId', deadlineRule.id).filter(deadlineTemp => deadlineTemp.status !== 'D').forEach(deadlineTemp => {
const _deadline = ((_work.get('deadline:' + deadlineTemp.id) ?? deadlineTemp) as Deadline).clone();
_deadline.status = 'U';
_deadline.addedOn = newHRTimestamp();
_deadline.addedBy = getCurrentUserId();
_deadline.importSource = targetImportSource;
_deadline.importId = mergeId;
if (_deadline.deadlineRuleId === deadlineRule.id) {
_deadline.deadlineRuleId = null;

}
_work.set('deadline:' + _deadline.id, _deadline);
store.dispatch(Actions.DeadlineActions.saveDeadlineQueue(_deadline));
});
store.getState().deadlineRules.getMappingFor('triggerRuleId', deadlineRule.id).filter(deadlineRuleTemp => deadlineRuleTemp.status !== 'D').forEach(deadlineRuleTemp => {
const _deadlineRule = ((_work.get('deadlineRule:' + deadlineRuleTemp.id) ?? deadlineRuleTemp) as DeadlineRule).clone();
_deadlineRule.status = 'U';
_deadlineRule.addedOn = newHRTimestamp();
_deadlineRule.addedBy = getCurrentUserId();
_deadlineRule.importSource = targetImportSource;
_deadlineRule.importId = mergeId;
if (_deadlineRule.triggerRuleId === deadlineRule.id) {
_deadlineRule.triggerRuleId = null;

}
_work.set('deadlineRule:' + _deadlineRule.id, _deadlineRule);
store.dispatch(Actions.DeadlineRuleActions.saveDeadlineRuleQueue(_deadlineRule));
});
store.getState().courtDeadlineRules.getMappingFor('deadlineRuleId', deadlineRule.id).filter(courtDeadlineRuleTemp => courtDeadlineRuleTemp.status !== 'D').forEach(courtDeadlineRuleTemp => {
const _courtDeadlineRule = ((_work.get('courtDeadlineRule:' + courtDeadlineRuleTemp.id) ?? courtDeadlineRuleTemp) as CourtDeadlineRule).clone();
_courtDeadlineRule.status = 'D';
_courtDeadlineRule.addedOn = newHRTimestamp();
_courtDeadlineRule.addedBy = getCurrentUserId();
_courtDeadlineRule.importSource = targetImportSource;
_courtDeadlineRule.importId = mergeId;

_work.set('courtDeadlineRule:' + _courtDeadlineRule.id, _courtDeadlineRule);
store.dispatch(Actions.CourtDeadlineRuleActions.saveCourtDeadlineRuleQueue(_courtDeadlineRule));
});



deadlineRule.status = 'D';
deadlineRule.addedOn = newHRTimestamp();
deadlineRule.addedBy = getCurrentUserId();
deadlineRule.importSource = targetImportSource;
deadlineRule.importId = mergeId;
store.dispatch(Actions.DeadlineRuleActions.removeDeadlineRuleQueue(deadlineRule));
}
export function replaceDeadlineRule(deadlineRule: DeadlineRule, replaceWith: DeadlineRule, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = deadlineRule.id;}
const _work = workingSet();
store.getState().deadlines.getMappingFor('deadlineRuleId', deadlineRule.id).filter(deadlineTemp => deadlineTemp.status !== 'D').forEach(deadlineTemp => {
const _deadline = ((_work.get('deadline:' + deadlineTemp.id) ?? deadlineTemp) as Deadline).clone();
_deadline.status = 'U';
_deadline.addedOn = newHRTimestamp();
_deadline.addedBy = getCurrentUserId();
_deadline.importSource = targetImportSource;
_deadline.importId = mergeId;
if (_deadline.deadlineRuleId === deadlineRule.id) {
_deadline.deadlineRuleId = replaceWith.id;

}
_work.set('deadline:' + _deadline.id, _deadline);
store.dispatch(Actions.DeadlineActions.saveDeadlineQueue(_deadline));
});
store.getState().deadlineRules.getMappingFor('triggerRuleId', deadlineRule.id).filter(deadlineRuleTemp => deadlineRuleTemp.status !== 'D').forEach(deadlineRuleTemp => {
const _deadlineRule = ((_work.get('deadlineRule:' + deadlineRuleTemp.id) ?? deadlineRuleTemp) as DeadlineRule).clone();
_deadlineRule.status = 'U';
_deadlineRule.addedOn = newHRTimestamp();
_deadlineRule.addedBy = getCurrentUserId();
_deadlineRule.importSource = targetImportSource;
_deadlineRule.importId = mergeId;
if (_deadlineRule.triggerRuleId === deadlineRule.id) {
_deadlineRule.triggerRuleId = replaceWith.id;

}
_work.set('deadlineRule:' + _deadlineRule.id, _deadlineRule);
store.dispatch(Actions.DeadlineRuleActions.saveDeadlineRuleQueue(_deadlineRule));
});
store.getState().courtDeadlineRules.getMappingFor('deadlineRuleId', deadlineRule.id).filter(courtDeadlineRuleTemp => courtDeadlineRuleTemp.status !== 'D').forEach(courtDeadlineRuleTemp => {
const _courtDeadlineRule = ((_work.get('courtDeadlineRule:' + courtDeadlineRuleTemp.id) ?? courtDeadlineRuleTemp) as CourtDeadlineRule).clone();
_courtDeadlineRule.status = 'U';
_courtDeadlineRule.addedOn = newHRTimestamp();
_courtDeadlineRule.addedBy = getCurrentUserId();
_courtDeadlineRule.importSource = targetImportSource;
_courtDeadlineRule.importId = mergeId;
if (_courtDeadlineRule.deadlineRuleId === deadlineRule.id) {
_courtDeadlineRule.deadlineRuleId = replaceWith.id;

}
_work.set('courtDeadlineRule:' + _courtDeadlineRule.id, _courtDeadlineRule);
store.dispatch(Actions.CourtDeadlineRuleActions.saveCourtDeadlineRuleQueue(_courtDeadlineRule));
});



return deadlineRule;
}
export function deleteImpactDeadlineRule(deadlineRule: DeadlineRule) {
const impacts: string[] = [];
const state = store.getState();
const deadlineDeadlineRuleIdImpact = state.deadlines.getMappingFor('deadlineRuleId', deadlineRule.id).filter(deadline => deadline.status !== 'D');
deadlineDeadlineRuleIdImpact.forEach(() => impacts.push('deadlines'));
const deadlineRuleTriggerRuleIdImpact = state.deadlineRules.getMappingFor('triggerRuleId', deadlineRule.id).filter(deadlineRule => deadlineRule.status !== 'D');
deadlineRuleTriggerRuleIdImpact.forEach(() => impacts.push('deadlineRules'));
const courtDeadlineRuleDeadlineRuleIdImpact = state.courtDeadlineRules.getMappingFor('deadlineRuleId', deadlineRule.id).filter(courtDeadlineRule => courtDeadlineRule.status !== 'D');
courtDeadlineRuleDeadlineRuleIdImpact.forEach(() => impacts.push('courtDeadlineRules'));



return util.countDistinct(impacts);
}
